import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function ApproverManage ( props ) {

    return <BasicCrudScreenType id="Approver" noEdit table="Approver" view="VwApprover" />

}

export default ApproverManage;
